<template>
    <div id="wsc_shop_app" :class="{
    'wc_content_container_inner': useRootContainer && !isMobile,
    'wc_content_container_mobile': useRootContainer && isMobile
    }">
        <router-view :name="mediaQueryDevice"></router-view>
    </div>
</template>

<script>
  import { mapActions, mapMutations, mapGetters } from 'vuex'
  import { initializeCart } from './store/plugins/cartStorage'

  export default {
    async mounted () {
      this.requestShop()
      await this.requestProducts()
      await initializeCart(this.$store)
      this.registerNavigationIEFix()
    },
    data () {
      return {
        mediaQueryDevice: 'mobile'
      }
    },
    computed: {
      ...mapGetters({
        useRootContainer: 'shop/getUseRootContainer',
        isMobile: 'shop/getMetaIsMobile'
      })
    },
    beforeMount () {
      const {body} = document
      const WIDTH = 768
      const RATIO = 0

      const handler = () => {
        if (!document.hidden) {
          let rect = body.getBoundingClientRect()
          let isMobile = rect.width - RATIO < WIDTH

          this.mediaQueryDevice = (isMobile ? 'mobile' : 'desktop')
          this.setMetaIsMobile(isMobile)
        }
      }

      document.addEventListener('visibilitychange', handler)
      window.addEventListener('DOMContentLoaded', handler)
      window.addEventListener('resize', handler)
      handler()

      this.setMetaIsEditor(this.inIframe())
    },
    methods: {
      ...mapMutations({
        setMetaIsMobile: 'shop/setMetaIsMobile',
        setMetaIsEditor: 'shop/setMetaIsEditor'
      }),
      ...mapActions({
        requestShop: 'shop/request',
        requestProducts: 'products/request'
      }),
      inIframe () {
        // test if we are inside a frame / in the editor
        // since window.top might not be defined or blocked due to same-origin policy,
        // we need to catch errors
        try {
          return window.self !== window.top
        } catch (e) {
          return true
        }
      },
      registerNavigationIEFix () {
        // Fix for IE, routing does not work in IE if elements are outside of vue application.
        // So we need to add an event to each link and trigger navigation manually
        let elements = document.getElementsByClassName('navigationElement shop')
        Array.prototype.forEach.call(elements, el => {
          let nodes = el.getElementsByTagName('A')
          if (nodes.length) {
            Array.prototype.forEach.call(nodes, node => {
              node.addEventListener('click', this.navigate)
            })
          }
        })
      },
      navigate (event) {
        let url = event.target.hash.replace('#', '')
        this.$router.push(url)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/App.vue